export function ProductListSkeleton () {
  return (
    <div className='flex flex-col'>
      {[1, 2, 3].map((index) => (
        <CartItemSkeleton key={index} />
      ))}
    </div>
  );
}

function CartItemSkeleton () {
  return (
    <div className='flex animate-pulse border-b  border-[#F4F4F4] py-4'>
      {/* Product Image Skeleton */}
      <div className='h-[90px] w-[90px] rounded bg-[#f2f3f5]' />
      
      <div className='flex-1 pl-3'>
        {/* Product Name Skeleton */}
        <div className='mb-2.5 h-4 w-4/5 rounded bg-[#f2f3f5]' />
        
        {/* Options Skeleton */}
        <div className='space-y-2'>
          <div className='h-3 w-2/5 rounded bg-[#f2f3f5]' />
          <div className='h-3 w-3/5 rounded bg-[#f2f3f5]' />
        </div>
        
        {/* Quantity and Price */}
        <div className='mt-4 flex items-center justify-between'>
          {/* Quantity Control Skeleton */}
          <div className='flex items-center space-x-2'>
            <div className='h-8 w-8 rounded bg-[#f2f3f5]' />
            <div className='h-8 w-8 rounded bg-[#f2f3f5]' />
            <div className='h-8 w-8 rounded bg-[#f2f3f5]' />
          </div>
          
          {/* Price Skeleton */}
          <div className='h-4 w-16 rounded bg-[#f2f3f5]' />
        </div>
      </div>
    </div>
  );
}

